import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const headerBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'flex-start', sm: 'center' },
    justifyContent: 'space-between',
    gap: 2,
    mb: 4,
};

export const titleStyles: SxProps<Theme> = {
    fontWeight: 700,
    letterSpacing: '-0.015em',
};

export const subtitleStyles: SxProps<Theme> = {
    color: 'text.secondary',
};

export const alertStyles: SxProps<Theme> = {
    mb: 3,
    borderRadius: 3,
};

export const loadingBoxStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    py: 8,
};

export const emptyStateBoxStyles: SxProps<Theme> = {
    textAlign: 'center',
    py: 8,
};

export const emptyStateIconStyles = (theme: Theme): SxProps<Theme> => ({
    fontSize: 64,
    color: theme.palette.grey[300],
    mb: 2,
});

/** Paper gives the table its own surface, and the container scrolls rather than the page. */
export const tableContainerStyles: SxProps<Theme> = {
    borderRadius: 3,
    border: '1px solid rgba(16,24,40,0.06)',
};

export const headerCellStyles: SxProps<Theme> = {
    fontWeight: 700,
    whiteSpace: 'nowrap',
};

export const actionsCellStyles: SxProps<Theme> = {
    textAlign: 'right',
    whiteSpace: 'nowrap',
};

/** Its own export rather than a spread of the two above: SxProps is a union, so spreading two of them does not typecheck. */
export const actionsHeaderCellStyles: SxProps<Theme> = {
    fontWeight: 700,
    textAlign: 'right',
    whiteSpace: 'nowrap',
};

/**
 * A deactivated clinic stays legible but visibly inert -- it has to remain readable,
 * since reactivating it is done from this row.
 */
export const rowStyles = (isActive: boolean): SxProps<Theme> => ({
    opacity: isActive ? 1 : 0.55,
});

/** Slug and calendar id are identifiers, so they read better in a mono face. */
export const identifierCellStyles: SxProps<Theme> = {
    fontFamily: 'monospace',
    fontSize: '0.85rem',
    color: 'text.secondary',
    maxWidth: 260,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

export const rowActionsBoxStyles: SxProps<Theme> = {
    display: 'inline-flex',
    gap: 1,
};
